import { Button, Input, Spinner } from 'components';
import * as yup from 'yup';
import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import DeliveryFollowListModal from '../DeliveryFollowListModal/DeliveryFollowListModal';
import { useDispatch } from 'react-redux';
import {
  removeShipmentTracking,
  setShipmentTracking,
} from 'redux/slices/shipment-tracking/ShipmentTrackingSlice';
import { yupResolver } from '@hookform/resolvers/yup';
import { 
  useLazyGetShipmentTrackingPublicQuery,
  useLazyGetShipmentTrackingAuthQuery 
} from 'redux/slices/shipment-tracking/ShipmentTrackingApi';
import { addAlertQueue } from 'redux/slices/snackbar/snackbarSlice';
import { getStoragedItem } from 'utils/helper';

const shipmentTrackingValidation = yup.object({
  takipNo: yup
    .string()
    .min(12, 'Takip numarası 12 haneli olmalıdır.')
    .required('Takip numarası boş bırakılamaz.'),
});

const DeliveryFollow = ({ page = '/' }) => {
  const [modalOpen, setModalOpen] = useState({
    open: false,
    data: null,
  });
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { control, handleSubmit, formState } = useForm({
    resolver: yupResolver(shipmentTrackingValidation),
  });

  const { errors } = formState;
  const [getShipmentTrackingPublic, { isFetching: isFetchingPublic }] =
    useLazyGetShipmentTrackingPublicQuery();
  const [getShipmentTrackingAuth, { isFetching: isFetchingAuth }] =
    useLazyGetShipmentTrackingAuthQuery();

  const isAuthenticated = !!getStoragedItem('clientToken');
  const isFetching = isFetchingPublic || isFetchingAuth;

  const onSubmit = async (data) => {
    try {
      let res;
      
      if (isAuthenticated) {
        res = await getShipmentTrackingAuth({
          shipmentNumber: data.takipNo,
        });
      } else {
        const recaptchaToken = await executeRecaptcha('shipment_tracking');
        res = await getShipmentTrackingPublic({
          shipmentNumber: data.takipNo,
          recaptchaToken: recaptchaToken,
        });
      }

      if (res.data?.msg) {
        dispatch(
          addAlertQueue({
            message: res.data.msg,
            status: 'error',
            show: true,
          })
        );
      } else {
        dispatch(setShipmentTracking(data.takipNo));
        setModalOpen({
          open: true,
          data: res.data,
        });
      }
    } catch (error) {
      console.error('Shipment tracking failed:', error);
      dispatch(
        addAlertQueue({
          message: isAuthenticated 
            ? 'Gönderi takibi sırasında bir hata oluştu.'
            : 'reCAPTCHA doğrulama hatası. Lütfen tekrar deneyin.',
          status: 'error',
          show: true,
        })
      );
    }
  };

  const handleStyle = () => {
    switch (page) {
      case 'login':
        return 'w-full';
      case '/':
        return 'absolute bottom-16 z-10 transform  translate-x-1/2 w-1/2';
      default:
        break;
    }
  };
  return (
    <div>
      <div className={handleStyle()}>
        <form
          className="grid grid-cols-12 md:gap-x-2 gap-x-0 md:gap-y-0 gap-y-2 items-end"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Controller
            name="takipNo"
            control={control}
            render={({ field }) => (
              <Input
                errors={errors?.takipNo?.message}
                maxLength={12}
                className="md:col-span-8 col-span-12 "
                placeholder="Takip Numarasını Girin"
                parentComponent="DeliveryFollow"
                {...field}
              />
            )}
          />
          <Button
            type="submit"
            textVariant="white"
            text={`${isFetching ? 'Aranıyor' : 'Takip Et'}`}
            className="!bg-orange md:col-span-4 col-span-12 !h-10"
            disabled={isFetching}
          />
        </form>
      </div>
      {isFetching ? (
        <Spinner isPending={isFetching} />
      ) : (
        <DeliveryFollowListModal
          open={modalOpen.open}
          onCancel={() => {
            setModalOpen({
              open: false,
              data: null,
            });
            dispatch(removeShipmentTracking());
          }}
          data={modalOpen.data}
        />
      )}
    </div>
  );
};

export default DeliveryFollow;

DeliveryFollow.propTypes = {
  page: PropTypes.string,
};
